import React, { useEffect, useState, useRef } from 'react';
import { Dimensions, Modal, TouchableOpacity, View, Animated, ScrollView, Platform, KeyboardAvoidingView } from 'react-native';
import { Icon } from "../icon/Icon";
import ThemeProvider from "@voltmoney/theme";
import { ColorTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
import { isFromiOSBrowser } from '../pages/utils';
export var BottomSheetAnimation;
(function (BottomSheetAnimation) {
    BottomSheetAnimation["SLIDE"] = "slide";
    BottomSheetAnimation["FADE"] = "fade";
    BottomSheetAnimation["NONE"] = "none";
})(BottomSheetAnimation || (BottomSheetAnimation = {}));
const BottomSheetMfAnimation = ({ children = React.createElement(React.Fragment, null), bottomChild = React.createElement(React.Fragment, null), modalVisible = false, onModalClose, onModalOpen, showClose = true, onClosePress, backgroundColor, animationType = BottomSheetAnimation.SLIDE, isFromSDKProcessingCard = false }) => {
    const [_modalVisible, setModalVisible] = useState(false);
    const [_backgroundColor, setBackgroundColor] = useState(undefined);
    const translateYAnim = useRef(new Animated.Value(Dimensions.get('window').height)).current;
    const screenHeight = Dimensions.get("window").height;
    const [footerHeight, setFooterHeight] = useState(0);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const screenWidth = Dimensions.get('window').width;
    const isLargeScreen = screenWidth >= 769;
    useEffect(() => {
        if (modalVisible === true) {
            openModal();
        }
        else {
            closeModal();
        }
    }, [modalVisible]);
    const openModal = () => {
        setModalVisible(true);
        Animated.timing(translateYAnim, {
            toValue: 0,
            duration: 350,
            useNativeDriver: true,
        }).start();
        onModalOpen && onModalOpen();
    };
    const closeModal = () => {
        Animated.timing(translateYAnim, {
            toValue: Dimensions.get('window').height,
            duration: 400,
            useNativeDriver: true,
        }).start(() => {
            setModalVisible(false);
            onModalClose && onModalClose();
        });
    };
    const disableBodyScroll = () => {
        if (isFromiOSBrowser()) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
        }
    };
    return (React.createElement(View, null,
        React.createElement(Modal, { visible: _modalVisible, animationType: 'none', transparent: true, presentationStyle: "overFullScreen", onRequestClose: closeModal, onShow: disableBodyScroll },
            React.createElement(KeyboardAvoidingView, { behavior: Platform.OS === 'ios' ? 'padding' : undefined, style: { flex: 1 } },
                React.createElement(View, { style: {
                        flex: 1,
                        justifyContent: 'flex-end',
                        alignItems: 'center'
                    } },
                    React.createElement(View, { style: { width: isLargeScreen ? 508 : '100%',
                            backgroundColor: (_backgroundColor || !modalVisible) ? _backgroundColor : 'rgba(0, 0, 0, 0.5)',
                            flex: 1,
                            justifyContent: 'flex-end', marginTop: isLargeScreen ? 84 : 0,
                            marginBottom: isLargeScreen ? 28 : 0, } },
                        React.createElement(Animated.View, { style: {
                                transform: [{ translateY: translateYAnim }],
                                width: '100%',
                                padding: 16,
                                borderTopRightRadius: 10,
                                borderTopLeftRadius: 10,
                                alignItems: 'center',
                                backgroundColor: 'white'
                            } },
                            showClose &&
                                React.createElement(View, { style: {
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                    } },
                                    React.createElement(TouchableOpacity, { style: {
                                            // backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
                                            // padding: 4,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: 24,
                                            height: 24,
                                            position: 'relative',
                                            borderRadius: 100
                                        }, onPress: () => {
                                            onClosePress &&
                                                onClosePress();
                                            closeModal();
                                        } },
                                        React.createElement(Icon, { name: IconTokens.SYSTEM_CANCEL_DLS, size: IconSizeTokens.LG, color: ColorTokens.Grey_Night }))),
                            React.createElement(ScrollView, { style: { maxHeight: screenHeight - 250, width: '100%', marginBottom: footerHeight }, keyboardShouldPersistTaps: "handled", showsVerticalScrollIndicator: false }, children),
                            bottomChild && (React.createElement(View, { onLayout: (event) => {
                                    setFooterHeight(event?.nativeEvent?.layout?.height);
                                }, style: {
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                } }, bottomChild)))))))));
};
export default BottomSheetMfAnimation;
